import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Button, ButtonGroup } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import projectImg from '../assets/images/greenctg.jpg';

const ProjectItemStyles = styled.div`
  .projectItem__img {
    width: 100%;
    height: 400px;
    overflow: hidden;
    border-radius: 12px;
    display: inline-block;
    border: 3px solid var(--gray-2);
    img {
      height: 100%;
    }
  }
  .projectItem__info {
    margin-top: 1rem;
    background-color: var(--deep-dark);
    padding: 1rem;
    border-radius: 12px;
  }

  .buttongroup {
    margin-top: 1rem;
    background-color: var(--gray-2);
    padding: 0.2rem;
    border-radius: 8px;
  }

  .buttongroupbtn {
    background-color: var(--gray-2);
  }
  .projectItem__title {
    font-size: 2.2rem;
  }
  .projectItem__desc {
    font-size: 1.6rem;
    font-family: 'RobotoMono Regular';
    margin-top: 1rem;
  }
  @media only screen and (max-width: 768px) {
    .projectItem__img {
      height: 350px;
    }
  }
`;

export default function ProjectItem({
  img = projectImg,
  title = 'Project Name',
  desc = 'Description',
  github = '#',
  LN = '#',
}) {
  return (
    <ProjectItemStyles>
      <Link to="/projects" className="projectItem__img">
        <img src={img} alt="project img" />
      </Link>
      <div className="projectItem__info">
        <Link to="#">
          <h3 className="projectItem__title">{title}</h3>
        </Link>
        <p className="projectItem__desc">{desc}</p>
        <ButtonGroup
          className="buttongroup"
          variant="contained"
          aria-label="outlined button group"
        >
          <Button className="buttongroupbtn" btnLink={github} color="secondary">
            <GitHubIcon fontSize="large" />
          </Button>
          <Button className="buttongroupbtn" onClick={LN}>
            <LinkedInIcon fontSize="large" />
          </Button>
        </ButtonGroup>
      </div>
    </ProjectItemStyles>
  );
}
